import {getVarType}     from "../../../../tools/utils";
import * as utils       from "../hooks/utils";
import TreeSelectOption from "../components/tree-select-option";
import {TreeProps}      from "../Props";

export default {
    data() {
        return {}
    },
    computed: {
        treeProps() {
            let props = {}
            Object.keys(TreeProps).map(key => {
                props[key] = this.$props[key]
            })

            props.renderContent = this.setRenderContent
            props.filterNodeMethod = this.setFilterNodeMethod
            props.nodeKey = this.nodeKey || this.valueKey || 'value'
            props.defaultExpandedKeys = this.setDefaultExpandedKeys
            props.expandOnClickNode = this.setExpandOnClickNode
            return props
        },
        propsMap() {
            return {
                value: this.dataKey,
                label: 'label',
                children: 'children',
                disabled: 'disabled',
                isLeaf: 'isLeaf',
                ...this.treeProps
            }
        },
        cacheOptionsMap() {
            return this.cacheOptions.reduce((prev, next) => ({...prev, [next.value]: next}), {})
        },
        defaultExpandedParentKeys() {
            return utils.toValidArray(this.modelValue)
                .map((value) => {
                    return utils.treeFind(
                        this.data || [],
                        (data) => data[this.dataKey] === value,
                        (data) => data.children,
                        (data, index, array, parent) => parent && parent[this.dataKey]
                    )
                })
                .filter((item) => utils.isValidValue(item))
        },
        // show current selected node only first time,
        // fix the problem of expanding multiple nodes when checking multiple nodes
        setDefaultExpandedKeys() {
            return this.defaultExpandedKeys
                ? this.defaultExpandedKeys.concat(this.defaultExpandedParentKeys)
                : this.defaultExpandedParentKeys
        },

        // only expand on click node when the `check-strictly` is false
        setExpandOnClickNode() {
            return !this.checkStrictly && this.expandOnClickNode
        },
        cacheOptions() {
            if (!this.renderAfterExpand && !this.lazy) return []
            const options = []
            utils.treeEach(
                this.data.concat(this.cacheData),
                (node) => {
                    const value = this.getNodeValByProp('value', node)
                    options.push({
                        value,
                        currentLabel: this.getNodeValByProp('label', node),
                        isDisabled: this.getNodeValByProp('disabled', node),
                    })
                },
                (data) => this.getNodeValByProp('children', data)
            )
            return options
        }
    },
    methods: {
        // 树节点的内容区的渲染 Function; Function(h, { node, data, store }
        setRenderContent(h, {node, data, store}) {
            return h(
                TreeSelectOption,
                {
                    props: {
                        value: this.getNodeValByProp('value', data),
                        label: this.getNodeValByProp('label', data),
                        disabled: this.getNodeValByProp('disabled', data),
                    }
                },
                [
                    this.renderContent
                        ? () => this.renderContent(h, {node, data, store})
                        : this.$scopedSlots.default
                            ? () => this.$scopedSlots.default({node, data, store})
                            : undefined
                ]
            )
        },

        // 对树节点进行筛选时执行的方法，返回 true 表示这个节点可以显示，返回 false 则表示这个节点会被隐藏
        setFilterNodeMethod(value, data, node) {
            if (this.filterNodeMethod) return this.filterNodeMethod(value, data, node)
            if (!value) return true
            return this.getNodeValByProp('label', data).includes(value)
        },

        // 当节点被点击的时候触发
        onNodeClick(data, node, e) {
            if (this.$listeners.hasOwnProperty('nodeClick')) {
                this.$listeners.nodeClick(data, node, e)
            }
            // `onCheck` is trigger when `checkOnClickNode`
            if (this.showCheckbox && this.checkOnClickNode) return

            // now `checkOnClickNode` is false, only no checkbox and `checkStrictly` or `isLeaf`
            if (!this.showCheckbox && (this.checkStrictly || node.isLeaf)) {
                if (!this.getNodeValByProp('disabled', data)) {
                    let select = this.$refs.select
                    let option = select.options.find(i => i.value === this.getNodeValByProp('value', data))
                    select.handleOptionSelect(option);
                }
            } else if (this.expandOnClickNode) {
                e.handleExpandIconClick()
            }
        },

        // 当复选框被点击的时候触发
        onCheck(data, params) {
            // ignore when no checkbox, like only `checkOnClickNode` is true
            if (!this.showCheckbox) return;

            const dataValue = this.getNodeValByProp('value', data)

            // fix: checkedKeys has not cached keys
            const uncachedCheckedKeys = params.checkedKeys

            const cachedKeys = this.multiple
                ? utils.toValidArray(this.modelValue).filter(
                    (item) =>
                        this.cacheOptionsMap.hasOwnProperty(item) &&
                        !this.$refs.tree.getNode(item) &&
                        !uncachedCheckedKeys.includes(item)
                )
                : []

            const checkedKeys = uncachedCheckedKeys.concat(cachedKeys)

            if (this.checkStrictly) {
                this.$emit(utils.INPUT_EVENT, this.multiple ? checkedKeys : checkedKeys.includes(dataValue) ? dataValue : undefined)
            }

            // only can select leaf node
            else {
                if (this.multiple) {
                    this.$emit(utils.INPUT_EVENT, this.$refs.tree.getCheckedKeys(true))
                } else {
                    // select first leaf node when check parent
                    const firstLeaf = utils.treeFind(
                        [data],
                        (data) =>
                            !utils.isValidArray(this.getNodeValByProp('children', data)) &&
                            !this.getNodeValByProp('disabled', data),
                        (data) => this.getNodeValByProp('children', data)
                    )

                    const firstLeafKey = firstLeaf ? this.getNodeValByProp('value', firstLeaf) : undefined

                    // unselect when any child checked
                    const hasCheckedChild =
                        utils.isValidValue(this.modelValue) &&
                        !!utils.treeFind(
                            [data],
                            (data) => this.getNodeValByProp('value', data) === this.modelValue,
                            (data) => this.getNodeValByProp('children', data)
                        )
                    this.$emit(utils.INPUT_EVENT, firstLeafKey === this.modelValue || hasCheckedChild ? undefined : firstLeafKey)
                }
            }

            this.$nextTick(() => {
                const checkedKeys = utils.toValidArray(this.modelValue)
                const tree = this.$refs.tree
                tree.setCheckedKeys(checkedKeys)

                if (this.$listeners.hasOwnProperty('check')) {
                    this.$listeners.check(data, {
                        checkedKeys: tree.getCheckedKeys(),
                        checkedNodes: tree.getCheckedNodes(),
                        halfCheckedKeys: tree.getHalfCheckedKeys(),
                        halfCheckedNodes: tree.getHalfCheckedNodes(),
                    })
                }
            })
        },

        getNodeValByProp(prop, data) {
            const propVal = this.propsMap[prop]
            if (getVarType(propVal) === 'function') {
                return propVal(data, this.$refs.tree.getNode(this.getNodeValByProp('value', data)))
            } else {
                return data[propVal]
            }
        }
    }
}
